import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validador direto (não factory). Todos os call-sites passam a referência
// (`[notEmptyArray]`) ao FormControl; o <ai-field> usa
// `hasValidator(notEmptyArray)` para decidir quando exibir o marcador
// visual de campo obrigatório, então a referência exportada deve ser
// estável. Emite apenas a chave `required` para casar com a mensagem
// padrão `Campo obrigatório` do <ai-field>.
export const notEmptyArray: ValidatorFn = (
    control: AbstractControl,
): ValidationErrors | null => {
    const value = control.value;
    if (Array.isArray(value) && value.length > 0) {
        return null;
    }
    return { required: true };
};
